export default "__VITE_ASSET__C4dGG4qc__ 584w";